"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBoxCheck = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconBoxCheck = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "m11.204 16.873 5.828-5.829L15.488 9.5l-4.284 4.285-2.16-2.16L7.5 13.169l3.704 3.704Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.887 5.536v15.268h18.6V5.48l-2.842-3.277h-13L2.886 5.536Zm2.15 13.118V7.907h14.3v10.747h-14.3Zm13.85-12.897H5.502l1.152-1.404H17.71l1.177 1.404Z"
}));
exports.IconBoxCheck = IconBoxCheck;
//# sourceMappingURL=IconBoxCheck.js.map